module.exports = __webpack_public_path__ + "static/stamped patio-71a6ab740ab857c125119b0211654ecf.jpg";